export const bankTransactionIncomeExpenseTypeLabels: Record<number, string> = {
  1: 'Income',
  2: 'Expense',
  3: 'Transfer',
};

export const bankTransactionIncomeExpenseTypeOptions = Object.entries(
  bankTransactionIncomeExpenseTypeLabels
).map(([value, label]) => ({
  value: Number(value),
  label,
}));
